
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { getLabels } from './Labels';
import { LabelContentItem, RestLabelResponse } from './LabelTypes';

export type UseLabelsParams<T> = {
  readonly existing?: Partial<T>;
  readonly transform: (response: RestLabelResponse) => T; // transform a label to a Certification (no elevated) or a Warning (severe)
}

export interface UseLabelsPropsBase {
  readonly contentItem: LabelContentItem;
}

export function makeFetchInitialStateForLabels<P extends UseLabelsPropsBase, S>(params: {
  readonly category: 'warning' | 'certification'; transform: (t: RestLabelResponse) => S;
}): undefined | ((bodyProps: P, dialogState: S) => Promise<S>) {
  if (!FeatureFlags.columnDQWsEnabled) {
    return undefined;
  }

  const { transform, category } = params;

  return async (bodyProps: P, dialogState: S) => {
    try {
      const { contentItem } = bodyProps;
      const result = await getLabels<S>({ transform, category, contentItems: [ contentItem ] });
      const labels = result.get({ contentId: contentItem.contentId, contentType: contentItem.contentType.toLowerCase() });

      if (!labels) {
        return dialogState;
      }

      const first = labels[0];
      if (!first) {
        return dialogState;
      }

      return first;
    } catch {
      return dialogState;
    }
  };
}
